export default __webpack_public_path__ + "static/media/ideal-logo.62a75f5c.svg";